import { render, staticRenderFns } from "./student-pickup-table.vue?vue&type=template&id=50283e31&scoped=true&"
import script from "./student-pickup-table.vue?vue&type=script&lang=js&"
export * from "./student-pickup-table.vue?vue&type=script&lang=js&"
import style0 from "./student-pickup-table.vue?vue&type=style&index=0&id=50283e31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50283e31",
  null
  
)

export default component.exports